import { minutesInHour, secondsInMinute } from 'helpers/timeConsts';
import formatMinutes from 'helpers/formatMinutes';

export default function getWorkingDuration(secondsValue: number) {
  const minutesValue = Math.floor(secondsValue / secondsInMinute);

  const hours = Math.floor(minutesValue / minutesInHour);
  const minutes = minutesValue % minutesInHour;

  if (hours === 0) {
    return `00:${formatMinutes(minutes)}`;
  }

  if (minutes === 0) {
    return `${hours}:00`;
  }

  return `${hours}:${formatMinutes(minutes)}`;
}
